import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const ImgCover = (props) => {
	 return (
		 <div className={classNames({
      'img-cover': true,
      [props.className]: props.className
      })}
		  style={{backgroundImage: `url('${props.src}')`}}
      >
		 </div> 
  );
}

ImgCover.propTypes = {
	src: PropTypes.string
}

export default ImgCover


// WEBPACK FOOTER //
// ./src/ui/utilities/img-cover.js